import { OrderStatus } from "./IOrder"


export interface ICustomerSettings{
    id?: number
    isShowPushNotification?: boolean
    isNotDisturbMode?:boolean
    notificationSchedule?: INotificationSchedule
    depotsIds?: number[]
    fuelTypesIds?: number[]
    notificationSettings?: ICustomerNotificationSettings[]
}

export interface ICustomerNotificationSettings{
    id: number
    settingsId: number
    statusText: string
    settingType: NotificationSettingType
    status?: OrderStatus
    isEmailNotificationEnable: boolean
    isPushNotificationEnable: boolean
    isVoceEnable: boolean
    isImportant: boolean
    children?: ICustomerNotificationSettings[]
}

export interface INotificationSchedule{
    id: number
    from: string
    to: string
    isOnlyImportantNotification?: boolean
    customerSettingsId: number
    notificationDays: number[]
}

export interface IUpdateCustomerNotificationTypeEnable{
    CustomerNotificationSettingsId: number
    isEmailNotificationEnable: boolean
    isPushNotificationEnable: boolean
}

export interface IUpdateCusotmerSettings{
    settingsId: number
    depotIds?: number[]
    fuelTypeIds?: number[]
}

export enum NotificationSettingType{
    OrderStatus,
    PricesLimits,
    System,
    Information
}

export enum DayOfWeek{
    Sunday,
    Monday,
    Tuesday,
    Wednesday,
    Thursday,
    Friday,
    Saturday
}